import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Status } from "@components/tailwindComponents";
import {
  ACTIF,
  TEMPORAIREMENT_INACTIF,
  DEFINITIVEMENT_INACTIF
} from "@helpers/_constants";
import { defaultUserImage } from "@utils/data";
import { formatDate } from "@utils/dateDisplay";

const StatusColor = {
  [ACTIF]: "arh-bg-[#49d4ab]",
  [TEMPORAIREMENT_INACTIF]: "arh-bg-[#f5d04b]",
  [DEFINITIVEMENT_INACTIF]: "arh-bg-[#f36242]"
};

export const NameRender = ({ rowData, headRef }) => (
  <div className="arh-flex arh-items-center tablet-850:arh-min-w-0">
    {rowData.new && <Status className="arh-mr-1 arh-bg-[#49d4ab]" />}

    <div
      className="arh-p-0 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor hover:!arh-text-darkGreyColor arh-flex arh-items-center arh-w-full tablet-850:arh-min-w-0"
    >
      <Avatar
        src={rowData.images?.[0]?.location || defaultUserImage}
        name={rowData.personnalInformation?.name}
        parentAvatar="tablet-850:arh-min-w-0"
        textStyle="desktop-middle:arh-w-24 arh-max-w-[12rem] arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-truncate tablet-850:arh-min-w-0"
        headRef={headRef}
      />
    </div>
  </div>
);

export const StatutRender = ({ rowData }) => {
  const { t: translate } = useTranslation("pages.employés.listEmployés");

  return (
    <div
      className="arh-p-0 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor hover:!arh-text-darkGreyColor arh-flex arh-items-center"
    >
      <Status className={`arh-mr-1 ${StatusColor[rowData.status] || ""}`} />

      <span className="arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor hover:!arh-text-darkGreyColor">
        {translate(rowData.status)}
      </span>
    </div>
  );
};

export const HiringDateRender = ({ rowData }) => {
  const { i18n } = useTranslation();
  const hiringDate =
    rowData?.defaultDateHiring && rowData?.seniorityDate
      ? rowData.seniorityDate
      : rowData?.hiringDate;

  return (
    <div className="arh-whitespace-nowrap arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor hover:!arh-text-darkGreyColor">
      {formatDate(hiringDate, i18n.language)}
    </div>
  );
};

export { AccessRender, HeaderAccessRender } from "./AccessRender";

export { GroupRender } from "./GroupRender";

export { PostRender } from "./PostRender";
